import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  PROXIES: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/proxies/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ADD_PROXY: ({ commit, dispatch }, proxy) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/proxies`, proxy).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_PROXIES: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/proxies`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROXY: ({ commit, dispatch }, proxyId) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/proxies/${proxyId}`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_PROXIES_COUNT: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/proxies/count `).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_PROXIES: ({ commit, dispatch }, proxyIds) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/proxies/delete`, { ids: proxyIds }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/proxy/actions.js